// src/types/message.ts
var MessageType = /* @__PURE__ */ ((MessageType2) => {
  MessageType2["START_APPLICATION"] = "START_APPLICATION";
  MessageType2["CREATE_REDIRECT"] = "CREATE_REDIRECT";
  MessageType2["TARGET_ADDRESS_ENTERED"] = "TARGET_ADDRESS_ENTERED";
  MessageType2["CLOSE_WIDGET"] = "CLOSE_WIDGET";
  return MessageType2;
})(MessageType || {});

// src/constants.ts
var IFRAME_STYLE = {
  width: "400px",
  height: "600px",
  border: "none",
  borderRadius: "24px",
  minWidth: "320px"
};
var IFRAME_PERMISSIONS = "camera *; microphone *; clipboard-read; clipboard-write; payment";
var PRODUCTION_WIDGET_URL = "https://app.swipelux.com";
var DEVELOPMENT_WIDGET_URL = "https://app.dev.swipelux.com";

// src/widget.ts
var WidgetIframeManager = class {
  constructor(iframe, settings, callbacks) {
    this.iframe = iframe;
    this.settings = settings;
    this.callbacks = callbacks;
    this.messageHandler = this.handleMessageEvent.bind(this);
  }
  initialize() {
    window.addEventListener("message", this.messageHandler);
    this.setupIframe();
  }
  destroy() {
    window.removeEventListener("message", this.messageHandler);
  }
  get widgetUrl() {
    var _a;
    return (_a = this.settings.widgetUrl) != null ? _a : PRODUCTION_WIDGET_URL;
  }
  get iframeSrc() {
    const iframeSrc = new URL(this.widgetUrl);
    iframeSrc.searchParams.set("api-key", this.settings.apiKey);
    return iframeSrc.toString();
  }
  setupIframe() {
    this.iframe.src = this.iframeSrc;
    this.iframe.onload = () => this.handleIframeLoad();
  }
  handleIframeLoad() {
    var _a;
    const message = {
      type: "START_APPLICATION" /* START_APPLICATION */,
      payload: {
        ...this.settings,
        merchantUrl: window.location.href,
        analyticsInfo: {
          screenWidth: window.innerWidth,
          screenHeight: window.innerHeight,
          merchantUrl: window.location.host,
          initTimestamp: Date.now()
        }
      }
    };
    (_a = this.iframe.contentWindow) == null ? void 0 : _a.postMessage(message, this.widgetUrl);
  }
  handleMessageEvent(event) {
    var _a, _b, _c, _d;
    if (!this.widgetUrl.includes(event.origin)) {
      return;
    }
    switch (event.data.type) {
      case "CREATE_REDIRECT" /* CREATE_REDIRECT */:
        window.open(event.data.payload.url, "_self");
        break;
      case "CLOSE_WIDGET" /* CLOSE_WIDGET */:
        (_b = (_a = this.callbacks).onClose) == null ? void 0 : _b.call(_a);
        break;
    }
    (_d = (_c = this.callbacks).onMessage) == null ? void 0 : _d.call(_c, event.data);
  }
};
export {
  DEVELOPMENT_WIDGET_URL,
  IFRAME_PERMISSIONS,
  IFRAME_STYLE,
  MessageType,
  PRODUCTION_WIDGET_URL,
  WidgetIframeManager
};
